module.exports = __webpack_public_path__ + "img/walletConnect.5b6c4d62.png";